import { Outlet } from "react-router-dom";
import { EtpNavBarFacture } from "../components/navbar/navbar-etp-invoice";

export default function EtpInvoiceLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <EtpNavBarFacture />
      <div className="flex-grow px-4 bg-white rounded-md">
        <Outlet />
      </div>
    </div>
  );
}
